import React from 'react';
import PropTypes from 'prop-types';
import LinkCard from '../../LinkCard/LinkCard';
import { FormattedMessage } from 'react-intl';

const HomepageBigPromise = () => {
  return (
    <section className="white">
      <div className="homepage-jumbotron">
        <div className="homepage-jumbotron-content">
          <h1>Now is the time to</h1>
          <h2>Drive Electric.</h2>
          <p className="title-banner">
            <FormattedMessage
              id="homepage.banner.title"
              defaultMessage="Estimate and compare costs, savings, incentives & more."
              description="Estimate and compare costs, savings, incentives & more. "
            />
          </p>
        </div>
      </div>
      <div className="link-card-container">
        <LinkCard type="BROWSE_VEHICLES" />
        <LinkCard type="COMPARE_VEHICLES" />
        <LinkCard type="DISCOVER_INCENTIVES" />
      </div>
    </section>
  );
};

export default HomepageBigPromise;

HomepageBigPromise.propTypes = {
  homePageBannerImage: PropTypes.string,
  userLocation: PropTypes.string,
};
